export default (values) => {
  const errors = {};

  if (!values.password) {
    errors.password = 'Required';
  }

  if (values.password && values.password.length < 8) {
    errors.password = 'Password min length 8 symbols';
  }

  if (!values.repeatPassword) {
    errors.repeatPassword = 'Required';
  }

  if (values.repeatPassword && values.password && values.password !== values.repeatPassword) {
    errors.repeatPassword = 'Password fields must be the same';
  }

  return errors;
};



// WEBPACK FOOTER //
// ./utils/resetPasswordPerformValidator.js